// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.counter-container {\n      text-align: center;\n}\n@media (min-width: 768px) {\n.counter-container {\n            align-self: flex-end;\n}\n}\n@media (min-width: 992px) {\n.counter-container {\n            align-self: center;\n}\n}\n.counter-container button {\n      margin: 0 10px;\n      padding: 5px 10px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
